import React from "react";
import { CheckCircle, FileText, Save, X } from "lucide-react";

// ===== DOCUMENTS MODAL COMPONENT =====
const DocumentsModal = ({
  styles,
  text,
  language,
  screenSize,
  fonts,
  spacing,
  isDarkMode,
  selectedEmployeeDocuments,
  documentChecklist,
  hasUnsavedChanges,
  savingDocument,
  onCheckboxChange,
  onSave,
  onBackdropClose,
  onClose,
}) => {
  if (!selectedEmployeeDocuments) {
    console.log('⚠️ No employee selected for documents modal');
    return null;
  }

  console.log('📂 Rendering DocumentsModal for:', selectedEmployeeDocuments.name);
  console.log('📋 Current checklist state:', documentChecklist);

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      onBackdropClose();
    }
  };

  // Checklist items: document field ↔ translation key
  const checklistItems = [
    { field: "photosCount", labelKey: "photos" },
    { field: "birthCertificateCopy", labelKey: "birthForm" },
    { field: "gradCertificateOriginal", labelKey: "graduation" },
    { field: "idCopy", labelKey: "idCopy" },
    { field: "noCrimeCertificate", labelKey: "criminalRecord" },
    { field: "laborLetterOriginal", labelKey: "workCertificate" },
    { field: "medicalCheckForm111", labelKey: "form111" },
  ];

  return (
    <div style={styles.modal} onClick={handleModalClick}>
      <div style={styles.viewModalContent} onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>
            <FileText size={screenSize === 'xs' ? 18 : 20} />
            {text[language].documentChecklist} - {
              selectedEmployeeDocuments.name
                ?.split(' ')
                .slice(0, 4)
                .join(' ')
            }

            {hasUnsavedChanges && (
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: '1rem',
                fontSize: fonts.small,
                color: '#f59e0b',
                fontWeight: '500'
              }}>
                ● {language === 'ar' ? 'تغييرات غير محفوظة' : 'Unsaved Changes'}
              </span>
            )}
          </h2>
          <button
            style={styles.closeBtn}
            onClick={onClose}
          >
            <X size={screenSize === "xs" ? 20 : 24} />
          </button>
        </div>

        {/* Document Checklist */}
        <div style={styles.viewModalBody}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: screenSize === 'xs' || screenSize === 'sm' ? '1fr' : 'repeat(2, 1fr)',
            gap: spacing.margin,
            padding: spacing.padding
          }}>
            {checklistItems.map(({ field, labelKey }) => (
              <label
                key={field}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  cursor: 'pointer',
                  padding: '1rem',
                  borderRadius: '8px',
                  backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                  border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
                  transition: 'all 0.2s ease'
                }}
              >
                <input
                  type="checkbox"
                  checked={documentChecklist[field]}
                  onChange={(e) => onCheckboxChange(field, e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    accentColor: '#10b981'
                  }}
                />
                <span style={{
                  fontSize: fonts.body,
                  color: isDarkMode ? '#fff' : '#1f2937',
                  fontWeight: '500',
                  flex: 1
                }}>
                  {text[language][labelKey]}
                </span>
                {documentChecklist[field] && (
                  <CheckCircle size={18} style={{ color: '#10b981' }} />
                )}
              </label>
            ))}
          </div>

          {/* Save Button */}
          <div style={{
            padding: spacing.padding,
            paddingTop: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: spacing.margin
          }}>
            <button
              onClick={onSave}
              disabled={!hasUnsavedChanges || savingDocument}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: screenSize === 'xs' ? '0.75rem 1.5rem' : '1rem 2rem',
                fontSize: fonts.body,
                fontWeight: '600',
                color: '#fff',
                backgroundColor: hasUnsavedChanges ? '#10b981' : '#94a3b8',
                border: 'none',
                borderRadius: '8px',
                cursor: hasUnsavedChanges && !savingDocument ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: savingDocument ? 0.7 : 1,
              }}
              onMouseEnter={(e) => {
                if (hasUnsavedChanges && !savingDocument) {
                  e.target.style.backgroundColor = '#059669';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (hasUnsavedChanges && !savingDocument) {
                  e.target.style.backgroundColor = '#10b981';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }
              }}
            >
              {savingDocument ? (
                <>
                  <Save size={18} style={{ animation: 'pulse 1.5s ease-in-out infinite' }} />
                  {language === 'ar' ? 'جاري الحفظ...' : 'Saving...'}
                </>
              ) : (
                <>
                  <Save size={18} />
                  {language === 'ar' ? 'حفظ التغييرات' : 'Save Changes'}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsModal;
